import { all, select, call, put } from 'redux-saga/effects';
import { PapiRequestDaSharedFavouritesSearch } from '@wix/da-types-papi';
import { normalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { deviationSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';
import {
  withOffset,
  selectors as streamSelectors,
} from '@wix/da-shared-react/pkg/Stream';
import { request } from '@wix/da-shared-react/pkg/xhr';
import { getSearchQuery } from '../../selectors/gallectionSection';
import { getProfileOwner } from '../../selectors/users';
import { GallectionSortOrder } from '../../../types/gallection';

function* fetchFromApi(params) {
  return yield call(request, {
    method: 'get',
    url: `/favourites/search`,
    params,
  });
}

// Separating this out from fetchMoreDeviationSearchResults just in case we need them decoupled in the future
// We can always combine them if it gets cumbersome to develop them separately.
export default function* fetchMoreFavouritesSearchResults(action) {
  const { streamId } = action;

  const [offset, limit, searchQuery, profileOwner, sortOrder] = yield all([
    select(state => withOffset.selectors.getNextOffset(state, streamId)),
    select(state => streamSelectors.getItemsPerFetch(state, streamId)),
    select(getSearchQuery),
    select(getProfileOwner),
    select(state =>
      streamSelectors.getStreamParam(state, streamId, 'sortOrder')
    ),
  ]);

  const queryParams: PapiRequestDaSharedFavouritesSearch = {
    faver_userid: profileOwner.user.userId,
    order:
      sortOrder === GallectionSortOrder.NEWEST
        ? 'most-recent'
        : 'popular-all-time',
    q: searchQuery,
    init: offset === 0,
    offset,
    limit,
  };

  const response = yield call(fetchFromApi, queryParams);

  if (response) {
    const { hasMore, nextOffset, estTotal, results: deviations } = response;
    const { result, entities } = normalize(deviations || [], [deviationSchema]);

    yield put(
      withOffset.actions.fetchSuccess({
        streamId,
        hasMore,
        nextOffset,
        items: result,
        entities,
        total: estTotal,
      })
    );
  }

  // TODO error catching
}
